export default "__VITE_ASSET__D1m880E1__"